<template>
  <form @submit.prevent="vLaunchCustomerResearch">
    
    <div class="order-research">
      <div class="form-field">
        <label>{{$_('customer_number')}}*</label>
        <input type="number" v-model="oCritere.fncli" class="form-element" />
      </div>
      <div class="form-field">
        <label>{{$_('customer_name')}}</label>
        <input type="text" v-model="oCritere.fnom" class="form-element" />
      </div>
      <div class="form-field">
        <label>{{$_('city')}}</label>
        <input type="text" v-model="oCritere.fville" class="form-element" />
      </div>
       <div class="form-field">
        <label>{{$_('country')}}</label>
        <Select 
          class="country-select no-margin form-element" 
          :placeholder="'Pays'" 
          :data="aPays" 
          @select-change="oCritere.fpays = $event.item" 
          :itemoption="['TCPAYS', 'TLIB_PAYS']" 
        />
      </div>
      <div class="form-field display-flex justify-content-end">
        <button class="btn">{{$_('research_button')}}</button>
      </div>
    </div>

    
  </form>
</template>

<script>
import Select from "@/common/components/widget/Select";

import customerService from '@/modules/client/services/customerService'

export default {
  components: {
    Select
  },
  data() {
    return {
      body: Array(),
      oCritere: {
        poffset: 0, 
        plimit: 1000,
        fncli: '',
        fnom: '',
        fville: '',
        fpays: ''
      },
      aPays: Array(),
      aVille: Array()
    }
  },
  created() {
    customerService.getCountry().then(res => {
      this.aPays = res.data.DS_O.OUT;
    });

    this.vLaunchCustomerResearch()
  },
  methods: {
    vLaunchCustomerResearch() {

        customerService.getCustomer(this.oCritere).then(res => {

          this.body = Array()

          res.data.DS_O.OUT.map((customer) => {
            this.body.push(customer)
          })

          this.$emit('customer-result', this.body);

        }).catch(err => {
          console.error(err)
        })
    }
  }
};
</script>

<style scoped>
.order-research {
  background-color: #f5f5f5;
  padding: 20px;
  display: flex;
}
form {
  width: 1;
}
.form-field {
  margin: 5px;
}
label {
  padding-left: 20px;
  text-align: left;
}
.form-element {
  width: 200px;
}

@media screen and (max-width: 800px) {
  .order-research {
    display: flex;
    flex-direction: column;
  }
  .order-research .form-field {
    width: 100%;
  }
  /deep/
  .order-research .form-field input {
    width: 100%;
  }
  .order-research .form-field .select-box {
    width: 100%;
  }
}
</style>